import React, { useEffect, useRef, useState } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import "../assets/style.scss"
import { useAppDispatch, useAppSelector } from "src/projects/ticarikredi/config/hook"
import { addThousandSeparator } from "@smpu-web/utils/utils"
import { setCalcDetails } from "src/projects/ticarikredi/state/calcdetails"
import Page from "@smpu-web/globalmodules/page"
import DataTable, { DateTableHandleType } from "@bappweb/datatable"
import Panel from "@bappweb/panel"

const CalculationDetail = () => {
  const calcResult = useAppSelector((state) => state.calcDetails.response?.calcResult)
  const vade = useAppSelector((state) => state.calcDetails.response?.vade)
  const amount = useAppSelector((state) => state.calcDetails.response?.amount)
  const showCalcDetails = useAppSelector((state) => state.calcDetails.response?.showCalcDetails)
  const dispatch = useAppDispatch()
  const refTable = useRef<DateTableHandleType>(null)
  const targetElement = useRef<HTMLDivElement>(null)

  const handleCloseClick = () => {
    dispatch(
      setCalcDetails({
        showCalcDetails: false
      })
    )
  }

  const gridOptions = {
    pageSize: 5,
    pageAble: true,
    noDataMessage: "Hesaplama detayı bulunamadı.",
    virtualization: false,
    virtualizationLoadSize: 250,
    className: 'datatable',
    scrollHeight: "600px",

    columns: [
      { title: "Taksit No", prop: "taksitNo", sortable: false },
      { title: "Taksit Tarihi", prop: "taksitTarihi", sortable: false },
      { title: "Taksit Tutarı", prop: "taksitTutari", sortable: false },
    ]
  }

  //her ayin hesaplama yapilan gününü alir
  const getCurrentDayInComingMonths = (index) => {
    var currentDate = new Date()
    var newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + index, currentDate.getDate())

    //eger gun eklenen ayda bulunmuyorsa (ornegin o ay 31 cekmiyorsa) o ayin son gununu alir (30, 29, 28)
    if (currentDate.getDate() > newDate.getDate()) {
      newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 0)
    }

    const date = newDate.getDate()
    const month = newDate.getMonth() + 1
    return `${date < 10 ? "0" + date : date}.${month < 10 ? "0" + month : month}.${newDate.getFullYear()}`
  }

  useEffect(() => {
    const mutableItems: any[] = [];

    if (!isNaN(calcResult?.aylikOdeme ?? NaN) && vade && vade > 0) {
      for (let i = 0; i < vade; i++) {
        let newItem = {
          taksitNo: i + 1,
          taksitTarihi: getCurrentDayInComingMonths(i + 1),
          taksitTutari: addThousandSeparator(Number(calcResult?.aylikOdeme).toFixed(2), true),
        }
        mutableItems.push(newItem)
      }
    }
    refTable.current?.loadWithDataArray(mutableItems)
  }, [vade, amount, showCalcDetails])

  useEffect(() => {
    if (showCalcDetails && targetElement.current) {
      targetElement.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [showCalcDetails])

  return (
    <Page className="calculation-detail-page">
      <div ref={targetElement}></div>
      <Panel hasFooter={false} noHeader className="calculation-detail-table-panel">
        <Panel.Body>
          <Block className="close">
            <Element type="span" className="bapp-link-icon btn-close" onClick={handleCloseClick}>
              <Element type="svg" stroke="currentColor" stroke-width="0" fill="currentColor" width="24" height="24" viewBox="0 0 32 32" className="bapp-icon" xmlns="https://www.w3.org/2000/svg">
                <Element type="path" d="M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z"></Element>
              </Element>
            </Element>
          </Block>
          <Element type="h2">Taksitli Ticari Kredi Ödeme Planı</Element>
          <DataTable ref={refTable} gridOptions={gridOptions} />
        </Panel.Body>
      </Panel>
    </Page>
  )
}

export default CalculationDetail
